export default function apiInterceptor(environmentService, API_TOKEN, OC_API, BC_API) {
  var service;

  service = {
    request: request,
  };

  return service;

  function request(config) {
    if (config.url && config.url.indexOf('oc-api/') >= 0) {
      config.url = config.url.replace('oc-api/', '');
      config.url = environmentService.getEnvironment().OC_API + config.url;
      config.headers[API_TOKEN.header] = OC_API.TOKEN;
      delete config.headers.Pragma;
      delete config.headers['Cache-Control'];
    }

    if (config.url && config.url.indexOf('bc-api/') >= 0) {
      config.url = config.url.replace('bc-api/', '');
      config.url = environmentService.getEnvironment().BC_API + config.url;
      config.headers[API_TOKEN.header] = BC_API.TOKEN;
      delete config.headers.Pragma;
      delete config.headers['Cache-Control'];
    }

    return config;
  }
}



// WEBPACK FOOTER //
// ./src/app/apiInterceptor.interceptor.js